type AnalyticsEvent = Record<string, string | number | boolean | undefined>;

export type ConversionEventName =
  | "phone_click"
  | "email_click"
  | "donate_click"
  | "sponsor_inquiry_click";

export function conversionEventForHref(href: string): ConversionEventName | undefined {
  if (href.startsWith("tel:")) return "phone_click";
  if (href.includes("mcfarlandwilions.com")) return "donate_click";
  if (href.includes("sponsor") || href.includes("Sponsorship")) return "sponsor_inquiry_click";
  if (href.startsWith("mailto:")) return "email_click";
  return undefined;
}

declare global {
  interface Window {
    gtag?: (command: "js" | "config" | "event", eventName: string | Date, parameters?: AnalyticsEvent) => void;
    dataLayer?: unknown[];
  }
}

let analyticsStarted = false;

export function startAnalytics() {
  if (analyticsStarted || typeof document === "undefined") return;
  analyticsStarted = true;

  const load = () => {
    if (document.querySelector('script[data-cwa-analytics="ga4"]')) return;
    window.dataLayer = window.dataLayer ?? [];
    window.gtag =
      window.gtag ??
      ((...args: unknown[]) => {
        window.dataLayer?.push(args);
      });
    window.gtag("js", new Date().toISOString());
    window.gtag("config", "G-4XYVP8ELEB");

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-4XYVP8ELEB";
    script.dataset.cwaAnalytics = "ga4";
    document.head.appendChild(script);
  };

  const interactionEvents: Array<keyof WindowEventMap> = ["pointerdown", "keydown", "scroll"];
  const loadOnInteraction = () => {
    interactionEvents.forEach((eventName) => window.removeEventListener(eventName, loadOnInteraction));
    load();
  };
  interactionEvents.forEach((eventName) => window.addEventListener(eventName, loadOnInteraction, { once: true, passive: true }));
  window.setTimeout(loadOnInteraction, 10000);
}

export function trackEvent(eventName: string, parameters?: AnalyticsEvent) {
  if (typeof window !== "undefined" && window.gtag) {
    if (parameters === undefined) {
      window.gtag("event", eventName);
      return;
    }
    window.gtag("event", eventName, parameters);
  }
}